import { SpecificRulesProduct } from '@teinor/erp/prices/types'
import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../globals/data'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../globals/dictionary'

export type DataPricesTy = SpecificRulesProduct[] | null
export type SetDataPricesTy = React.Dispatch<React.SetStateAction<DataPricesTy>>

interface ModalCreateProductSpecificPricesLogicProps {
    myDataPrices?: DataPricesTy
}

const useModalCreateProductSpecificPricesLogic = ({ myDataPrices }: ModalCreateProductSpecificPricesLogicProps) => {
    const [dataPrices, setDataPrices] = useState<DataPricesTy>(null)
    
    const getDataPrices = useCallback(async () => {
        const result: SpecificRulesProduct[] = []
        const myDataDict = dictionaryComplexFromJsonArr(myDataPrices || [], 'SpecificPriceRuleId')
        const specificPriceRules = await twinFetchPostJSON('/api/app/product/specificPrice/getAllSpecificPriceRules', {})
        if (specificPriceRules) {
            for (const specificPriceRule of specificPriceRules) {
                if (myDataDict?.[specificPriceRule.id]) {
                    const element = myDataDict?.[specificPriceRule.id]
                    result.push({ ...specificPriceRule, SpecificPriceRuleId: element.SpecificPriceRuleId, units: parseFloat(String(element.units)), price: element.price, calculated_price: parseFloat(String(element.calculated_price)), cost: parseFloat(String(element.cost)), tag: 'T' + element.SpecificPriceRuleId, SpecificPriceRule: specificPriceRule, ProductId: 0, weight: parseFloat(String(element.weight)), calculatedWeight: parseFloat(String(element.calculatedWeight)), margin: parseFloat(String(element.margin)), calculatedCost: parseFloat(String(element.calculatedCost)) })
                } else {
                    result.push({ ...specificPriceRule, SpecificPriceRuleId: specificPriceRule.id, units: 1, price: null, calculated_price: 0, cost: 0, tag: 'T' + specificPriceRule.id, _old_price: 0, SpecificPriceRule: specificPriceRule, ProductId: 0, Product: undefined, weight: 0, calculatedWeight: 0, margin: 0 })
                }
            }
            setDataPrices(result)
        }
    }, [setDataPrices, myDataPrices])

    const beforeSubmitAddSpecificPrices = useCallback((vals: TwinDictionary) => {
        if (dataPrices && dataPrices.length) {
            vals['specificPrices'] = dataPrices
        }
        return true
    }, [dataPrices])
    
    useEffect(() => {
        getDataPrices()
    }, [getDataPrices])

    return { dataPrices, setDataPrices, beforeSubmitAddSpecificPrices, getDataPrices }
}

export default useModalCreateProductSpecificPricesLogic